<template>
  <section>
    <div class="row">
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="waitingDialogs"
          title="Wartende Dialoge"
          :value="waitingDialogs"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="newVerifiedToday"
          title="Neue | Verif. Heute"
          :value="newVerifiedToday"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="fakesOnlineCount"
          title="Fakes online"
          :value="fakesOnlineCount"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <customers-online-card id="cusotmersOnline"></customers-online-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="revenueToday"
          title="Umsatz Heute"
          :value="revenueToday"
        >
        </dashboard-info-card>
      </div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card id="openAsas" title="Offene ASA" :value="openAsas">
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="newVerifiedMonth"
          title="Neue | Verif. Monat"
          :value="newVerifiedMonth"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="insOutsToday"
          title="INs | OUTs Heute"
          :value="insOutsToday"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="visitors"
          title="Besucher Heute"
          :value="visitors"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="revenueMonth"
          title="Umsatz Monat"
          :value="revenueMonth"
        ></dashboard-info-card>
      </div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="inModeration"
          title="Mods ges. | ASA Mods"
          :value="inModeration"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="loginsCount"
          title="Logins Heute | Monat"
          :value="loginsCount"
        >
        </dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="insOutsMonth"
          title="INs | OUTs Monat"
          :value="insOutsMonth"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="visitorsThisMonth"
          title="Besucher Monat"
          :value="visitorsThisMonth"
        ></dashboard-info-card>
      </div>
      <div class="col-xl-2 col-lg-4 col-md-6 col-sm-12">
        <dashboard-info-card
          id="revenueLastMonth"
          title="Umsatz letzter Monat"
          :value="revenueLastMonth"
        ></dashboard-info-card>
      </div>
      <div class="offset-xl-1 offset-lg-0 offset-md-0 offset-sm-0"></div>
    </div>
    <online-moderators-information-table
      @count-update="updateInModeration"
      class=" d-block"
    ></online-moderators-information-table>
    <message-queue-table
      @count-update="updateWaitingDialogCount"
      class="d-block"
    ></message-queue-table>
    <waiting-room-dialogs-table class="d-block"></waiting-room-dialogs-table>
  </section>
</template>

<script lang="babel">
import CustomersOnlineCard from "@/components/CustomersOnlineCard";
import OnlineModeratorsInformationTable from "@/components/tables/OnlineModeratorsInformationTable";
import MessageQueueTable from "@/components/tables/MessageQueueTable";
import WaitingRoomDialogsTable from "@/components/tables/WaitingRoomDialogsTable";
import { formatCurrency } from "@/js/currency";
import { union } from "lodash";
import DashboardInfoCard from "src/components/UIComponents/Cards/DashboardInfoCard";


export default {
  components: {
    CustomersOnlineCard,
    OnlineModeratorsInformationTable,
    MessageQueueTable,
    WaitingRoomDialogsTable,
    DashboardInfoCard
  },
  data() {
    return {
      canFetch: true,
      insToday: null,
      outsToday: null,
      insMonth: null,
      outsMonth: null,
      newCustomers: null,
      verifiedCustomers: null,
      newCustomersThisMonth: null,
      verifiedCustomersThisMonth: null,
      openAsas: null,
      waitingDialogs: null,
      visitors: null,
      visitorsThisMonth: null,
      update_interval_id: null,
      inModeration: null,
      revenueMonth: null,
      revenueLastMonth: null,
      revenueToday: null,
      reloadTimeout: null,
      fetchInterval: null,
      loginsCount: "0 / 0",
    };
  },
  computed: {
    fakesOnlineCount() {
      return this.thousandSeprator(union(this.$store.getters['online/onlines'].filter(online => online.p === true), Laravel.online).length.toString());
    },
    dashboardData() {
      return this.$store.getters['dashboard/dashboardData'];
    },
    newVerifiedToday() {
      let percent = ![0, '0', null].includes(this.newCustomers) ? Math.round((this.verifiedCustomers / this.newCustomers) * 100) : 0;
      let formatedNewCustomers = this.thousandSeprator(this.newCustomers);
      let formatedVerifiedCustomers = this.thousandSeprator(this.verifiedCustomers);
      return `${formatedNewCustomers} | ${formatedVerifiedCustomers} | ${percent}%`;
    },
    newVerifiedMonth() {
      let percent = ![0, '0', null].includes(this.newCustomersThisMonth) ? Math.round((this.verifiedCustomersThisMonth / this.newCustomersThisMonth) * 100) : 0;
      let formatedCustomersThisMonth = this.thousandSeprator(this.newCustomersThisMonth);
      let formatedVerifiedCustomersThisMonth = this.thousandSeprator(this.verifiedCustomersThisMonth);
      return `${formatedCustomersThisMonth} | ${formatedVerifiedCustomersThisMonth} | ${percent}%`;
    },
    insOutsToday() {
     return this.insToday+" | "+ this.outsToday;
    },
    insOutsMonth() {
     return this.insMonth+" | "+ this.outsMonth;
    }
  },
  methods: {
      thousandSeprator(amount) {
        if (!['', undefined, 0, '0', null, NaN].includes(amount)) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
          return 0;
        }
    },
    updateInModeration(count) {
      this.inModeration = count;
    },
    updateWaitingDialogCount(count) {
      this.waitingDialogs = this.thousandSeprator(count);
    },
    getRevenue() {
      return this.$http.get("/api/v1/transaction/stats")
      .then(({ data }) => {
        this.revenueToday = formatCurrency(data.totalToday);
        this.revenueMonth = formatCurrency(data.totalMonth);
        this.revenueLastMonth = formatCurrency(data.totalLastMonth);
      });
    },
    getINsAndOUTsCount() {
      return this.$http.get("/api/v1/message/count-ins-outs-daily")
      .then(({ data }) => {
        this.insToday = this.thousandSeprator(data.ins);
        this.outsToday = this.thousandSeprator(data.outs);
      });
    },
    getMontlyINsAndOUTsCount() {
      return this.$http.get("/api/v1/message/count-ins-outs-monthly")
      .then(({ data }) => {
        this.insMonth = this.thousandSeprator(data.ins);
        this.outsMonth = this.thousandSeprator(data.outs);
      });
    },

    getCustomersCount() {
      return this.$http.get("/api/v1/user/daily-new-users")
      .then(({ data }) => {
        this.newCustomers = data.customer;
        this.verifiedCustomers = data.verified;
      });
    },
    getCustomersThisMonthCount() {
      return this.$http.get("/api/v1/user/monthly-new-users")
      .then(({ data }) => {
        this.newCustomersThisMonth = data.customer;
        this.verifiedCustomersThisMonth = data.verified;
      });
    },
    getOpenAsas() {
      return this.$http.get("/api/v1/asa/countOpenAsas")
      .then(({ data }) => {
        this.openAsas = this.thousandSeprator(data.amount);
      });
    },
    getVisitorCount() {
      return this.$http.get("/api/v1/visitor-daily-count").then(({data}) => {
        this.visitors = this.thousandSeprator(data);
      });
    },
    getVisitorThisMonthCount() {
      return this.$http.get("/api/v1/visitor-monthly-count").then(({data}) => {
        this.visitorsThisMonth = this.thousandSeprator(data);
      });
    },
    getLoginsCount() {
      return this.$http.get("/api/v1/user/logins-count").then(({data}) => {
        this.loginsCount = this.thousandSeprator(data.today)+" | "+this.thousandSeprator(data.month);
      });
    },
    fetchData() {
      if (this.canFetch) {
        this.canFetch = false;
        return Promise.all([
        this.getRevenue(),
        this.getINsAndOUTsCount(),
        this.getMontlyINsAndOUTsCount(),
        this.getCustomersCount(),
        this.getVisitorThisMonthCount(),
        this.getCustomersThisMonthCount(),
        this.getOpenAsas(),
        this.getVisitorCount(),
        this.getLoginsCount()
        ]).finally(() => this.canFetch = true);
      }
    },
  },
  created() {
    this.fetchData();
    this.fetchInterval = setInterval(() => {
      this.fetchData();
    }, 3500);
    this.reloadTimeout = setTimeout(() => {
      location.reload(true);
    }, 300000);
  },
  beforeDestroy() {
    this.canFetch = false;
    clearTimeout(this.reloadTimeout);
    clearInterval(this.fetchInterval);
  },
};
</script>
